import React from 'react';

const SvgStaffActive = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.727 20.447C19.272 19.171 18.267 18.044 16.87 17.24C15.473 16.436 13.761 16 12 16C10.239 16 8.527 16.436 7.13 17.24C5.733 18.044 4.728 19.171 4.273 20.447"
        stroke="#0081FF"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z"
        stroke="#0081FF"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default SvgStaffActive;
